// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dhdJX","right":"styles_right__2w6q8"};